import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const PageUnderConstruction = () => {
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    // GSAP Animation for Title - Letter by Letter Animation
    const title = titleRef.current;
    gsap.fromTo(
      title.children,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        stagger: 0.1, // Adds delay between each letter
        duration: 0.8,
        ease: 'back.out(1.7)',
      }
    );

    // GSAP Animation for Description
    gsap.fromTo(
      descriptionRef.current,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, delay: 1.5, duration: 0.8 }
    );

    // GSAP Animation for Contact Info
    gsap.fromTo(
      contactRef.current,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, delay: 2.5, duration: 0.8 }
    );
  }, []);

  return (
    <div className="flex flex-col items-center  min-h-screen text-center p-6 pt-44 bg-black">
      {/* Title */}
      <h1
        className="text-2xl md:text-6xl font-bold text-white mb-4"
        ref={titleRef}
      >
        {Array.from('Page Under Construction!!').map((letter, index) => (
          <span
            key={index}
            className="inline-block"
            style={{ minWidth: letter === ' ' ? '0.5rem' : 'auto' }} // Preserve space between words
          >
            {letter === ' ' ? '\u00A0' : letter}{' '}
            {/* Render non-breaking space */}
          </span>
        ))}
      </h1>

      {/* Description Text */}
      <p className="text-base md:text-2xl text-white mb-4" ref={descriptionRef}>
        We are working hard to bring this page to life. Stay tuned for updates!
      </p>

      {/* Contact Information */}

      <p className="text-white text-lg md:text-xl" ref={contactRef}>
        Contact For More Info:{' '}
        <a href="mailto:example@example.com" className="text-blue-400 ">
          pos_support@insureefficient.com
        </a>{' '}
        |{' '}
        <a href="tel:+1234567890" className="text-blue-400 ">
          +91 7400063232
        </a>
      </p>
    </div>
  );
};

export default PageUnderConstruction;
